import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConfigService } from "src/app/core/config.service";
import { VsphereChartsData, VsphereResourceDetails, VsphereResources } from "./vsphere-resources.model";
import {VsphereResourceTypeEnum} from "src/app/shared/enum/vsphere-resource-type.enum";

@Injectable({
    providedIn: 'root'
})
export class VsphereResourcesService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadVsphereResources(serverId: string){
        return this.httpClient.get<VsphereResources>(`${this.configService.config.apiUrl}/iac/resources/vsphere?server=${serverId}`)
        .pipe(
            map((response=>{
                const data: any[] = []
                const vsphereEnumKeys = Object.keys(VsphereResourceTypeEnum);
                for(let type in response){
                    const resources = response[type as keyof VsphereResources]
                    if(vsphereEnumKeys.includes(type)){
                        data.push(...resources.checked.map((value) => {return {...value, type: type}}))
                        data.push(...resources.unchecked.map((value) => {return {...value, type: type}}))
                        data.push(...resources.ignored.map((value) => {return {...value, type: type}}))
                    }
                }
                return data
            }))
        )
    }

    loadVsphereResourceDetails(serverId: string, resourceId: string){
        return this.httpClient.get<VsphereResourceDetails>(`${this.configService.config.apiUrl}/iac/resources/vsphere/details?server=${serverId}&resource_id=${resourceId}`)
    }

    loadVsphereMeasures(serverId: string, start_date: string, end_date: string, granularity: string){
        return this.httpClient.get<VsphereChartsData>(`${this.configService.config.apiUrl}/iac/resources/vsphere/measures?server=${serverId}&start_date=${start_date}&end_date=${end_date}&granularity=${granularity}`)
    }
}
